import React from 'react';

import ToggleSync from './ToggleSync';

export default function ToggleSuppliersSync(props) {
    return (
        <ToggleSync
            integrationConfigured={props.integrationConfigured}
            syncEnabled={props.syncEnabled}
            action={props.action}
            toggleUrl={props.toggleUrl}
            model={props.model}
            modelName={$t('Suppliers')}
            syncNowUrl={props.syncNowUrl}
            toggleCallback={() => {
                props.toggleCallback();
            }}
            toggleModalId={'enable-suppliers-sync'}
            importNowMessage={$t('Import {{model}} now', { model: $t('Suppliers') })}
        />
    );
}
